module.exports = __webpack_public_path__ + "img/dnd_3_splash.086e0b5f.jpg";